/** How a listing price relates to the market band when ceiling-only enforcement applies. */
export type EnforcedBandPriceStatus = "in_band" | "below_band" | "above_band";

export function classifyEnforcedBandPrice(
  priceNaira: number,
  band: Pick<{ min: number; max: number }, "min" | "max">,
): EnforcedBandPriceStatus {
  if (priceNaira > band.max) return "above_band";
  if (priceNaira < band.min) return "below_band";
  return "in_band";
}

/** Ceiling-only: allow at or below band max; below band min is allowed (faster sale). */
export function isPriceAllowedUnderCeilingEnforcement(
  priceNaira: number,
  band: Pick<{ min: number; max: number }, "min" | "max">,
): boolean {
  return priceNaira <= band.max;
}

/** True when price sits inside the typical market band (inclusive). */
export function isPriceWithinTypicalBand(
  priceNaira: number,
  band: Pick<{ min: number; max: number }, "min" | "max">,
): boolean {
  return priceNaira >= band.min && priceNaira <= band.max;
}
